import { createSelector } from 'reselect';
import moment from 'moment';

export const Types = {
  GET_MESSAGES_REQUEST: 'kafka/GET_MESSAGES_REQUEST',
  GET_MESSAGES_SUCCESS: 'kafka/GET_MESSAGES_SUCCESS',
  GET_MESSAGES_FAILURE: 'kafka/GET_MESSAGES_FAILURE',
};

const initialState = {
  messages: {
    data: [],
    loading: false,
    page: 1,
    total: 0,
  },
};

export default function kafka(state = initialState, action) {
  switch (action.type) {
    case Types.GET_MESSAGES_REQUEST:
      return {
        ...state,
        messages: {
          ...state.messages,
          loading: true,
        },
      };
    case Types.GET_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: {
          ...state.messages,
          loading: false,
          data: action.payload.messages.data,
          page: action.payload.page,
          totals: 2000,
        },
      };
    case Types.GET_MESSAGES_FAILURE:
      return {
        ...state,
        messages: {
          ...state.messages,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getMessagesRequest: (page = 1, filters = null) => ({
    type: Types.GET_MESSAGES_REQUEST,
    payload: { page, filters },
  }),

  getMessagesSuccess: (messages, page) => ({
    type: Types.GET_MESSAGES_SUCCESS,
    payload: { messages, page },
  }),

  getMessagesFailure: () => ({
    type: Types.GET_MESSAGES_FAILURE,
  }),
};

export const Selectors = {
  messages: createSelector(
    state => state,
    messages =>
      messages.map(message => ({
        ...message,
        attributes: {
          ...message.attributes,
          processed_at: message.attributes.processed_at !== null ? moment(message.attributes.processed_at).format('DD/MM/YYYY [às] HH:mm') : '-',
          created_at: message.attributes.created_at !== null ? moment(message.attributes.created_at).format('DD/MM/YYYY [às] HH:mm') : '-',
        },
      })),
  ),
};
